import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6c906e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "card-header is-unselectable",
  style: {"cursor":"pointer"}
}
const _hoisted_3 = {
  key: 0,
  class: "card-header-icon px-0"
}
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = {
  key: 0,
  class: "card-content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-primary",
  max: "100"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "card-content has-text-danger has-text-centered"
}
const _hoisted_9 = { class: "icon is-large" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BulmaButton = _resolveComponent("BulmaButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("p", {
        class: "card-header-title",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, _toDisplayString(_ctx.header), 1),
      (_ctx.refreshable)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createVNode(_component_BulmaButton, {
              class: "tag icon is-primary",
              onClick: _ctx.refresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-arrows-rotate",
                  spin: _ctx.is_open && _ctx.loading
                }, null, 8, ["spin"])
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "card-header-icon",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: 'fa-solid fa-angle-' + (_ctx.is_open ? 'down' : 'right')
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    (_ctx.is_open)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-ban",
                      size: "3x"
                    })
                  ])
                ]))
              : _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}